import * as React from 'react';
import { Grid } from '@material-ui/core';

export function EquationContainer({ children }: { children: JSX.Element }): JSX.Element {
  return (
    <Grid container justifyContent="center">
      <Grid item xs={12} md={6} lg={3}>
        {children}
      </Grid>
    </Grid>
  );
}
